import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-manage-roles',
  templateUrl: './manage.component.html',
  styleUrls: ['./manage.component.scss'],
})
export class ManageRolesComponent implements OnInit {

  @Input() url = 'firms/clients/roles';
  @Input() title = 'Manage Roles';
  // Which actions to offer (the API enforces them too) - contact roles pass contact_roles_* in
  @Input() can_create = true;
  @Input() can_update = true;
  @Input() can_delete = true;

  is_editing = false;
  roles: any[] = [];
  level_error = '';

  add_role: any = {
    guid: '',
    title: '',
    colour: '#90ee90',
    description: '',
    level: null,
  };

  constructor(
    public modalController: ModalController,
    private apiService: ApiService,
    public globalService: GlobalService
  ) {}

  ngOnInit() {
    this.GetData();
  }

  async GetData() {
    let data: any = await this.apiService.get(this.url);
    if (data.success) {
      this.roles = (data.data || []).sort((a: any, b: any) => a.level - b.level);
    }
  }

  // Returns true if the role is young enough (< 5 min) to allow deletion.
  // The API returns created_date without a timezone suffix so we append 'Z'
  // to force UTC parsing before comparing against Date.now() (also UTC).
  CanDelete(role: any): boolean {
    if (!role.created_date) return true;
    const created = new Date(role.created_date + 'Z').getTime();
    return (Date.now() - created) < 5 * 60 * 1000;
  }

  ValidateLevel(): boolean {
    const level = this.add_role.level;
    if (level === null || level === undefined || level === '') {
      this.level_error = 'Level is required.';
      return false;
    }
    if (!Number.isInteger(Number(level)) || Number(level) < 1) {
      this.level_error = 'Level must be a whole number of 1 or higher.';
      return false;
    }
    const duplicate = this.roles.find(r => Number(r.level) === Number(level) && r.guid !== this.add_role.guid);
    if (duplicate) {
      this.level_error = `Level ${level} is already assigned to "${duplicate.title}". Each level must be unique.`;
      return false;
    }
    this.level_error = '';
    return true;
  }

  async Create() {
    if (!this.ValidateLevel()) return;
    this.globalService.presentLoading('Creating...', 9999);
    let data: any = await this.apiService.post(this.url, this.add_role);
    this.globalService.presentToastMessage(data.message, data.success);
    if (data.success) {
      await this.GetData();
      this.CancelEdit();
    }
    this.globalService.dismissLoading();
  }

  async Update() {
    if (!this.ValidateLevel()) return;
    this.globalService.presentLoading('Updating...', 9999);
    let data: any = await this.apiService.put(`${this.url}/${this.add_role.guid}`, this.add_role);
    this.globalService.presentToastMessage(data.message, data.success);
    if (data.success) {
      await this.GetData();
      this.CancelEdit();
    }
    this.globalService.dismissLoading();
  }

  CancelEdit() {
    this.is_editing = false;
    this.level_error = '';
    this.add_role = {
      guid: '',
      title: '',
      colour: '#90ee90',
      description: '',
      level: null,
    };
  }

  EditRole(role: any) {
    this.is_editing = true;
    this.level_error = '';
    this.add_role = { ...role };
  }

  async Delete(role: any) {
    if (!this.CanDelete(role)) {
      this.globalService.presentToastMessage('Roles cannot be deleted after 5 minutes of creation.', false);
      return;
    }
    let data: any = await this.apiService.delete(`${this.url}/${role.guid}`, null);
    this.globalService.presentToastMessage(data.message, data.success);
    if (data.success) {
      await this.GetData();
      this.CancelEdit();
    }
  }
}
